module.exports = __webpack_public_path__ + "static/media/local-k-light.cde69f96.png";